import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

const FormGroup = require("live/components/forms/ui/form-group");

const ListHeader = ({ newUserGroup, filterFunction }) => {
  return (
    <Header>
      <Button
        className="buttonadd"
        onClick={(e) => {
          newUserGroup();
        }}
      >
        <i class="fa fa-plus-circle" />
        New User Group
      </Button>

      <input
        type="text"
        autoFocus="autofocus"
        className="search-text-box"
        onChange={(e) => {
          filterFunction(e.target.value);
        }}
      />
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  border: 1px solid #dddee1;

  padding-left: 5px;
  height: 60px;
  width: 100%;

  background-color: #eee;

  .buttonadd {
    background-color: #37a3ef;
    color: white;
  }

  .search-text-box {
    margin: 0px 15px;
    width: 40%;

    :focus {
      border: 1px solid #37a3ef;
    }
  }
`;

export default ListHeader;
